import { render, staticRenderFns } from "./SearchSuggestionsList.vue?vue&type=template&id=4e06ed45&"
import script from "./SearchSuggestionsList.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports